
import React, { useContext, useEffect, useState } from "react";
import LogoResp from "./../img/logos/logo_webtelco_horizontal_version.svg";
import LogoRespSmall from "./../img/logos/logo_webtelco_small.svg";
import LogoResp2 from "./../img/logos/logo_webtelco_horizontal_version2.svg";
import LogoRespSmall2 from "./../img/logos/logo_webtelco_small2.svg";
import Balance from "../components/caisse"
import { useAlert } from "../contexts/alertContext";
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Icon from "@mdi/react";
import { mdiMenuClose } from "@mdi/js";
import ParamContext from "../contexts/paramContext";


export default function PageHeader({ defaultPath, dynamicComponentForPath }) {
    const { noMenu,openMenu, hideMenu, handleHideMenu } = useAlert()
    const size = useWindowSize();
    const Gfunc = require("../Gfunc");
    const param = useContext(ParamContext);


    function useWindowSize() {
        const [windowSize, setWindowSize] = useState({
            width: window.innerWidth,
            height: window.innerHeight,
        });

        useEffect(() => {
            function handleResize() {
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            }
            window.addEventListener("resize", handleResize);
            return () => {
                window.removeEventListener("resize", handleResize);
            };
        }, []);

        return windowSize;
    }
    return (
        <div id="appHeader">
            {(size.width <= Gfunc.mediumScreen) ? 

            <div  className={"boxHeader "+(noMenu?"noMenuHeader":!openMenu?"smallMenuHeader":"bigMenuHeader")} >
                <Toolbar sx={{ minHeight: "0px !important", height: "100%" }}>
                    {(noMenu || size.width <= Gfunc.smallScreen) && <IconButton
                        size="large"
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        sx={{ mr: 2 }}
                        onClick={() => handleHideMenu(false)}
                        style={{ padding: "2px", background: "var(--primary-main)", marginLeft: "-6px", marginRight: "12px" }}
                    >
                        <Icon path={mdiMenuClose} size="30px" color={"white"} />
                    </IconButton>}
                    <div id="header" className={"noMenuHeader"}>
                        {defaultPath && (
                            <div style={{ width: "100%" }}>
                                <div className="line-container">
                                    {(size.width >= Gfunc.smallScreen) && <>
                                        <span className="pageTitleElem">
                                            {dynamicComponentForPath?.parent}
                                        </span>
                                        <div className="horizontal-line"></div>
                                    </>}
                                    <span className="pageTitleElem">
                                        {dynamicComponentForPath?.itself}
                                    </span>
                                    <div className="horizontal-line"></div>
                                    <div className="pageTitleElemMain">
                                        <span className="pageTitleElem">
                                            {dynamicComponentForPath?.description}
                                        </span>
                                    </div>
                                </div>
                                <Balance small={true} />
                            </div>)}</div>

                    <div id="disconnect" >
                        {(size.width > 460) ? <img
                            src={param.app === "1" ? LogoResp : LogoResp2}
                            alt="logo"
                            style={{ height: "30px", marginRight: "0px" }}
                        /> : <img
                                src={param.app === "1" ? LogoRespSmall : LogoRespSmall2}
                            alt="logo"
                            style={{ height: "30px", marginRight: "0px" }}
                        />}
                    </div>
                </Toolbar>
            </div> : <div id="header" className={noMenu?"noMenuHeader":!openMenu?"smallMenuHeader":"bigMenuHeader"}>
            {(noMenu) && <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2 }}
                onClick={() => handleHideMenu(false)}
                    style={{ padding: "4px", background: "var(--primary-main)", marginLeft: "-6px", marginRight: "8px" }}
            >
                    <Icon path={mdiMenuClose} size="30px" color={"white"} />
            </IconButton>}
            {defaultPath && (
                    <div>
                        <div className="line-container">
                            <span className="pageTitleElem">
                                {dynamicComponentForPath?.parent}
                            </span>
                            <div className="horizontal-line"></div>
                            <span className="pageTitleElem">
                                {dynamicComponentForPath?.itself}
                            </span>
                            <div className="horizontal-line"></div>
                            <div className="pageTitleElemMain">
                                <span className="pageTitleElem">
                                    {dynamicComponentForPath?.description}
                                </span>
                            </div>
                        </div>
                        <Balance />

                    </div>
            )}

                <div id="disconnect" >
                <img
                        src={param.app === "1" ? LogoResp : LogoResp2}
                    alt="logo"
                    style={{ height: "45px", marginRight: "4px",padding: "5px 0px" }}
                />
            </div>
                </div>}
        </div>
    );
}


